import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {firstValueFrom, Subject, takeUntil} from 'rxjs';
import {PromotionService} from '../../services/promotion.service';
import {StorageService} from '../../services/storage-service';
import {RegionService} from '../../services/region-service';

@Component({
  selector: 'app-splash',
  imports: [RouterLink],
  templateUrl: './splash.component.html',
  styleUrl: './splash.component.scss'
})
export class SplashComponent implements OnInit, OnDestroy {
  onDestroy$ = new Subject<boolean>();

  constructor(private route: ActivatedRoute,
              private router: Router,
              private storageService: StorageService,
              private regionService: RegionService,
              private promotionService: PromotionService) {
  }


  ngOnInit() {

    // Handle converting ref to promotion code
    this.route.queryParams.pipe(takeUntil(this.onDestroy$)).subscribe(queryParams => {
      const ref = queryParams['ref'];
      if (ref) this.storePromotionCode(ref).finally()
    })
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  async storePromotionCode(ref: string) {
    const regionSlug = await this.regionService.getRegionSlug()
    const promotion = await firstValueFrom(this.promotionService.getByRef(ref, regionSlug).pipe(takeUntil(this.onDestroy$))).catch(() => Promise.resolve(null));

    // Store the ref and promotion code for sign up
    if (ref) this.storageService.add(StorageService.REF, ref)
    if (promotion) this.storageService.add(StorageService.PROMOTION_CODE, promotion.code)

    // Remove the ref from the URL
    this.router.navigate([], {queryParams: {'ref': null}, queryParamsHandling: 'merge'}).finally()
  }

}
